import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconStorage = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M2 20h20v-4H2zm2-3h2v2H4zM2 4v4h20V4zm4 3H4V5h2zm-4 7h20v-4H2zm2-3h2v2H4z" />
  </SvgIcon>
);

export default IconStorage;



// WEBPACK FOOTER //
// ./src/components/icons/IconStorage.js